import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-top-counter-team-registration',
  templateUrl: './top-counter-team-registration.component.html',
  styleUrls: ['./top-counter-team-registration.component.css']
})
export class TopCounterTeamRegistrationComponent implements OnInit {
  @Input() Title1: string;
  @Input() Title2: string;

  @Input() Count1: number;
  @Input() Count2: number;
  @Input() currency: boolean;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/partial/top-counter-team-registration/top-counter-team-registration.component.ts